import React from 'react';
import Balancer from 'react-wrap-balancer';

import styled from 'styled-components';

import ScrollReveal from '@components/common/ScrollReveal';
import { Container } from '@components/parts/Container';
import { Link } from '@components/parts/Link';

import { LinkProps } from '@customTypes/Link';
import { TDIs } from '@customTypes/TDI';

type Props = {
  tdis: TDIs;
  action?: LinkProps;
  textAreaPadding?: string;
};

const Wrapper = styled.div<{ textAreaPadding: string | null }>`
  margin-top: 50px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (min-width: 768px) {
    margin-top: 70px;
    flex-direction: row;
  }
  .card {
    min-height: 347px;
    height: 347px;
    position: relative;
    overflow: hidden;
    flex: 1;
    background-color: #f3f4f8;
    div.text-area {
      height: 100%;
      padding: ${(props) => props.textAreaPadding || '24px'};
      padding-bottom: 0;
      h4 {
        font-weight: 700;
      }
      p {
        padding-top: 12px;
        color: #62656a;
      }
    }
    div.image-container {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 200px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: bottom right;
    }
  }
`;

export const TDICards: React.FC<Props> = (props) => {
  const { tdis, action, textAreaPadding = null } = props;
  return (
    <Container>
      <Wrapper textAreaPadding={textAreaPadding}>
        {tdis.map((tdi, idx) => (
          <ScrollReveal key={`${idx}`} className="card" intervalDelay={idx * 300}>
            <div className="text-area">
              <h4>{tdi.title}</h4>
              <p>
                <Balancer>{tdi.description}</Balancer>
              </p>
            </div>
            <div
              className="image-container"
              style={{ backgroundImage: `url("${tdi.image?.data?.attributes?.url || ''}")` }}
            ></div>
          </ScrollReveal>
        ))}
      </Wrapper>
      {action ? <Link {...action} className={`${action.className} mb-50`} /> : null}
    </Container>
  );
};
